<template>
  <div class="row middle-align-flex fixed-top header-bar">
    <div class="col-12 col-sm-6 col-lg-8">
      <a :href="byodMainUrl">
        <img class='logo' v-bind:src='logo' :alt='altText'>
      </a>
    </div>
    <div class="d-sm-block col-sm-6 col-lg-4">
      <div class="row header-bar__links">
        <div class="header-bar__links-item" v-bind:class="helpClass" v-if="!help.excluded">
          <a v-bind:style="{color: providerColor}" :href="help.url" target="_blank">{{ help.text || $t('byodHelp') }}</a>
        </div>
        <div class="header-bar__links-item" v-bind:class="requirementsClass" v-if="!requirements.excluded">
          <a v-bind:style="{color: providerColor}" v-bind:href="requirements.url" target="_blank">{{ requirements.text || $t('byodRequirements') }}</a>
        </div>
        <div class="header-bar__links-item" v-bind:class="languageButtonClass" v-if="multipleLanguages && !multipleLanguages.excluded">
          <button
            class='language-selector'
            v-on:click="toggleLanguage(defaultLanguage)"
            v-bind:style="{color: providerColor}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 8C16 9.06667 15.8667 10 15.4667 11.0667C15.0667 12.1333 14.5333 12.8 13.8667 13.6C13.2 14.4 12.4 14.9333 11.4667 15.3333C10.5333 15.7333 9.6 15.8667 8.53333 16H8.4H8.26667C8.26667 16 8.26667 16 8.13333 16C8 16 8.13333 16 8 16C6.93333 16 5.86667 15.7333 4.93333 15.3333C4 14.9333 3.06667 14.4 2.4 13.6C1.73333 12.8 1.06667 12 0.666667 11.0667C0.266667 10.1333 0 9.06667 0 8C0 6.93333 0.266667 5.86667 0.666667 4.93333C1.06667 4 1.6 3.06667 2.4 2.4C3.2 1.73333 4 1.06667 4.93333 0.666667C5.86667 0.266667 6.93333 0 8 0C8 0 8 0 8.13333 0C8.26667 0 8.13333 0 8.26667 0H8.4H8.53333C9.6 0 10.5333 0.266667 11.4667 0.8C12.4 1.33333 13.2 1.86667 13.8667 2.53333C14.5333 3.2 15.0667 4.13333 15.4667 5.06667C15.8667 6 16 6.93333 16 8ZM1.33333 5.86667C1.2 6.26667 1.2 6.53333 1.06667 6.93333C0.933333 7.33333 1.06667 7.6 1.06667 8C1.06667 8.4 1.06667 8.93333 1.2 9.33333C1.33333 9.73333 1.33333 10.1333 1.46667 10.5333C1.6 10.5333 1.86667 10.4 2.26667 10.4C2.66667 10.4 3.06667 10.2667 3.73333 10.2667C3.73333 9.86667 3.6 9.6 3.6 9.2C3.6 8.8 3.6 8.4 3.6 8.13333C3.6 7.86667 3.6 7.6 3.6 7.2C3.6 6.8 3.6 6.66667 3.73333 6.4C2.93333 6.26667 2.4 6.13333 2 6C1.6 5.86667 1.46667 5.86667 1.33333 5.86667ZM5.6 1.46667C5.2 1.6 4.8 1.73333 4.4 2C4 2.26667 3.6 2.53333 3.33333 2.8C3.06667 3.06667 2.66667 3.46667 2.4 3.86667C2.13333 4.26667 1.86667 4.53333 1.73333 4.93333C1.86667 4.93333 2.13333 5.06667 2.4 5.06667C2.66667 5.06667 3.2 5.2 3.73333 5.2C4 4.53333 4.26667 3.73333 4.53333 3.06667C4.8 2.4 5.2 1.86667 5.6 1.46667ZM1.86667 11.4667C2.13333 11.8667 2.4 12.1333 2.66667 12.4C2.93333 12.6667 3.2 13.0667 3.46667 13.3333C3.73333 13.6 4.13333 13.8667 4.53333 14C4.93333 14.1333 5.33333 14.4 5.6 14.5333C5.2 14.1333 4.93333 13.6 4.53333 13.0667C4.13333 12.5333 4.13333 11.8667 3.86667 11.2C3.46667 11.2 2.93333 11.2 2.66667 11.3333C2.4 11.4667 2.13333 11.4667 1.86667 11.4667ZM4.53333 8C4.53333 8.4 4.53333 8.66667 4.53333 9.06667C4.53333 9.46667 4.66667 9.73333 4.66667 10.1333C5.06667 10.1333 5.46667 10.1333 6 10C6.53333 9.86667 6.93333 10 7.6 10V6.53333C7.06667 6.53333 6.53333 6.53333 6 6.53333C5.46667 6.53333 5.06667 6.53333 4.66667 6.4C4.66667 6.66667 4.66667 6.93333 4.53333 7.2C4.4 7.46667 4.53333 7.73333 4.53333 8ZM7.46667 1.06667C7.2 1.2 6.93333 1.33333 6.66667 1.6C6.4 1.86667 6.13333 2.13333 5.86667 2.53333C5.6 2.93333 5.46667 3.33333 5.2 3.86667C4.93333 4.4 4.93333 4.8 4.8 5.33333C5.2 5.33333 5.6 5.33333 6 5.46667C6.4 5.6 6.93333 5.46667 7.46667 5.46667V1.06667ZM7.46667 10.9333C6.93333 10.9333 6.53333 10.9333 6 10.9333C5.46667 10.9333 5.2 10.9333 4.8 11.0667C4.93333 11.6 5.2 12 5.33333 12.4C5.46667 12.8 5.73333 13.2 6 13.6C6.26667 14 6.53333 14.2667 6.8 14.4C7.06667 14.5333 7.33333 14.8 7.6 14.9333V10.9333H7.46667ZM8.53333 1.06667V5.46667C9.06667 5.46667 9.6 5.46667 10 5.46667C10.4 5.46667 10.9333 5.46667 11.2 5.33333C11.0667 4.8 10.9333 4.26667 10.8 3.86667C10.6667 3.46667 10.4 2.93333 10.1333 2.53333C9.86667 2.13333 9.6 1.86667 9.33333 1.6C9.06667 1.33333 8.8 1.2 8.53333 1.06667ZM8.53333 10C9.06667 10 9.6 10 10.1333 10C10.6667 10 11.0667 10 11.4667 10.1333C11.4667 9.86667 11.6 9.46667 11.6 9.06667C11.6 8.66667 11.6 8.4 11.6 8C11.6 7.73333 11.6 7.46667 11.6 7.2C11.6 6.93333 11.6 6.66667 11.4667 6.4C11.0667 6.4 10.6667 6.53333 10.1333 6.53333C9.6 6.53333 9.06667 6.53333 8.53333 6.53333V10ZM8.53333 14.9333C8.8 14.8 9.06667 14.6667 9.33333 14.5333C9.6 14.4 9.86667 14 10.1333 13.7333C10.4 13.4667 10.5333 12.9333 10.6667 12.5333C10.8 12.1333 11.0667 11.6 11.0667 11.0667C10.6667 11.0667 10.2667 11.0667 9.86667 10.9333C9.46667 10.8 8.93333 10.9333 8.4 10.9333V14.9333H8.53333ZM14.2667 4.93333C13.8667 4.13333 13.4667 3.6 12.8 2.93333C12.1333 2.26667 11.4667 1.86667 10.8 1.6C11.0667 2 11.4667 2.66667 11.6 3.2C11.7333 3.73333 12 4.53333 12.1333 5.33333C12.8 5.2 13.2 5.2 13.6 5.06667C14 4.93333 14.2667 4.93333 14.2667 4.93333ZM10.8 14.4C11.4667 14.1333 12.1333 13.7333 12.6667 13.2C13.2 12.6667 13.7333 12.1333 14.1333 11.4667C14 11.4667 13.7333 11.3333 13.4667 11.3333C13.2 11.3333 12.6667 11.2 12.1333 11.2C12 11.8667 11.8667 12.4 11.6 12.9333C11.3333 13.4667 11.0667 14 10.8 14.4ZM14.5333 10.5333C14.6667 10.1333 14.8 9.73333 14.9333 9.33333C15.0667 8.93333 15.0667 8.4 15.0667 8C15.0667 7.46667 15.0667 7.06667 14.9333 6.66667C14.8 6.26667 14.6667 5.73333 14.5333 5.33333L14.6667 5.86667C14.6667 5.86667 14.4 5.86667 14.1333 6C13.8667 6.13333 13.2 6.13333 12.4 6.26667C12.4 6.53333 12.4 6.8 12.5333 7.06667C12.6667 7.33333 12.5333 7.6 12.5333 8C12.5333 8.4 12.5333 8.8 12.5333 9.06667C12.5333 9.33333 12.4 9.86667 12.4 10.1333C13.0667 10.2667 13.4667 10.2667 13.8667 10.4C14.2667 10.5333 14.4 10.5333 14.5333 10.5333Z" fill="#113050"/>
            </svg> {{ defaultLanguage }}
          </button>
        </div>
      </div>
    </div>
    <div class="header-bar__menu" :class="{ 'is-menu-open': openMenu }" @click="openMenu = !openMenu">
      <div class="header-bar__menu-line"></div>
      <div class="header-bar__menu-line"></div>
      <div class="header-bar__menu-line"></div>
    </div>
    <div class="header-bar__mobile-nav" :class="{ 'is-open': openMenu }">
      <div class="header-bar__mobile-links">
        <div class="header-bar__link-item" v-if="!help.excluded">
          <a v-bind:style="{color: providerColor}" :href="help.url" target="_blank">{{ help.text || $t('byodHelp') }}</a>
        </div>
        <div class="header-bar__link-item" v-if="!requirements.excluded">
          <a v-bind:style="{color: providerColor}" v-bind:href="requirements.url" target="_blank">{{ requirements.text || $t('byodRequirements') }}</a>
        </div>
        <div class="header-bar__link-item" v-if="multipleLanguages && !multipleLanguages.excluded">
          <button
            class='language-selector'
            v-on:click="toggleLanguage(defaultLanguage); openMenu = false"
            v-bind:style="{color: providerColor}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 8C16 9.06667 15.8667 10 15.4667 11.0667C15.0667 12.1333 14.5333 12.8 13.8667 13.6C13.2 14.4 12.4 14.9333 11.4667 15.3333C10.5333 15.7333 9.6 15.8667 8.53333 16H8.4H8.26667C8.26667 16 8.26667 16 8.13333 16C8 16 8.13333 16 8 16C6.93333 16 5.86667 15.7333 4.93333 15.3333C4 14.9333 3.06667 14.4 2.4 13.6C1.73333 12.8 1.06667 12 0.666667 11.0667C0.266667 10.1333 0 9.06667 0 8C0 6.93333 0.266667 5.86667 0.666667 4.93333C1.06667 4 1.6 3.06667 2.4 2.4C3.2 1.73333 4 1.06667 4.93333 0.666667C5.86667 0.266667 6.93333 0 8 0C8 0 8 0 8.13333 0C8.26667 0 8.13333 0 8.26667 0H8.4H8.53333C9.6 0 10.5333 0.266667 11.4667 0.8C12.4 1.33333 13.2 1.86667 13.8667 2.53333C14.5333 3.2 15.0667 4.13333 15.4667 5.06667C15.8667 6 16 6.93333 16 8ZM1.33333 5.86667C1.2 6.26667 1.2 6.53333 1.06667 6.93333C0.933333 7.33333 1.06667 7.6 1.06667 8C1.06667 8.4 1.06667 8.93333 1.2 9.33333C1.33333 9.73333 1.33333 10.1333 1.46667 10.5333C1.6 10.5333 1.86667 10.4 2.26667 10.4C2.66667 10.4 3.06667 10.2667 3.73333 10.2667C3.73333 9.86667 3.6 9.6 3.6 9.2C3.6 8.8 3.6 8.4 3.6 8.13333C3.6 7.86667 3.6 7.6 3.6 7.2C3.6 6.8 3.6 6.66667 3.73333 6.4C2.93333 6.26667 2.4 6.13333 2 6C1.6 5.86667 1.46667 5.86667 1.33333 5.86667ZM5.6 1.46667C5.2 1.6 4.8 1.73333 4.4 2C4 2.26667 3.6 2.53333 3.33333 2.8C3.06667 3.06667 2.66667 3.46667 2.4 3.86667C2.13333 4.26667 1.86667 4.53333 1.73333 4.93333C1.86667 4.93333 2.13333 5.06667 2.4 5.06667C2.66667 5.06667 3.2 5.2 3.73333 5.2C4 4.53333 4.26667 3.73333 4.53333 3.06667C4.8 2.4 5.2 1.86667 5.6 1.46667ZM1.86667 11.4667C2.13333 11.8667 2.4 12.1333 2.66667 12.4C2.93333 12.6667 3.2 13.0667 3.46667 13.3333C3.73333 13.6 4.13333 13.8667 4.53333 14C4.93333 14.1333 5.33333 14.4 5.6 14.5333C5.2 14.1333 4.93333 13.6 4.53333 13.0667C4.13333 12.5333 4.13333 11.8667 3.86667 11.2C3.46667 11.2 2.93333 11.2 2.66667 11.3333C2.4 11.4667 2.13333 11.4667 1.86667 11.4667ZM4.53333 8C4.53333 8.4 4.53333 8.66667 4.53333 9.06667C4.53333 9.46667 4.66667 9.73333 4.66667 10.1333C5.06667 10.1333 5.46667 10.1333 6 10C6.53333 9.86667 6.93333 10 7.6 10V6.53333C7.06667 6.53333 6.53333 6.53333 6 6.53333C5.46667 6.53333 5.06667 6.53333 4.66667 6.4C4.66667 6.66667 4.66667 6.93333 4.53333 7.2C4.4 7.46667 4.53333 7.73333 4.53333 8ZM7.46667 1.06667C7.2 1.2 6.93333 1.33333 6.66667 1.6C6.4 1.86667 6.13333 2.13333 5.86667 2.53333C5.6 2.93333 5.46667 3.33333 5.2 3.86667C4.93333 4.4 4.93333 4.8 4.8 5.33333C5.2 5.33333 5.6 5.33333 6 5.46667C6.4 5.6 6.93333 5.46667 7.46667 5.46667V1.06667ZM7.46667 10.9333C6.93333 10.9333 6.53333 10.9333 6 10.9333C5.46667 10.9333 5.2 10.9333 4.8 11.0667C4.93333 11.6 5.2 12 5.33333 12.4C5.46667 12.8 5.73333 13.2 6 13.6C6.26667 14 6.53333 14.2667 6.8 14.4C7.06667 14.5333 7.33333 14.8 7.6 14.9333V10.9333H7.46667ZM8.53333 1.06667V5.46667C9.06667 5.46667 9.6 5.46667 10 5.46667C10.4 5.46667 10.9333 5.46667 11.2 5.33333C11.0667 4.8 10.9333 4.26667 10.8 3.86667C10.6667 3.46667 10.4 2.93333 10.1333 2.53333C9.86667 2.13333 9.6 1.86667 9.33333 1.6C9.06667 1.33333 8.8 1.2 8.53333 1.06667ZM8.53333 10C9.06667 10 9.6 10 10.1333 10C10.6667 10 11.0667 10 11.4667 10.1333C11.4667 9.86667 11.6 9.46667 11.6 9.06667C11.6 8.66667 11.6 8.4 11.6 8C11.6 7.73333 11.6 7.46667 11.6 7.2C11.6 6.93333 11.6 6.66667 11.4667 6.4C11.0667 6.4 10.6667 6.53333 10.1333 6.53333C9.6 6.53333 9.06667 6.53333 8.53333 6.53333V10ZM8.53333 14.9333C8.8 14.8 9.06667 14.6667 9.33333 14.5333C9.6 14.4 9.86667 14 10.1333 13.7333C10.4 13.4667 10.5333 12.9333 10.6667 12.5333C10.8 12.1333 11.0667 11.6 11.0667 11.0667C10.6667 11.0667 10.2667 11.0667 9.86667 10.9333C9.46667 10.8 8.93333 10.9333 8.4 10.9333V14.9333H8.53333ZM14.2667 4.93333C13.8667 4.13333 13.4667 3.6 12.8 2.93333C12.1333 2.26667 11.4667 1.86667 10.8 1.6C11.0667 2 11.4667 2.66667 11.6 3.2C11.7333 3.73333 12 4.53333 12.1333 5.33333C12.8 5.2 13.2 5.2 13.6 5.06667C14 4.93333 14.2667 4.93333 14.2667 4.93333ZM10.8 14.4C11.4667 14.1333 12.1333 13.7333 12.6667 13.2C13.2 12.6667 13.7333 12.1333 14.1333 11.4667C14 11.4667 13.7333 11.3333 13.4667 11.3333C13.2 11.3333 12.6667 11.2 12.1333 11.2C12 11.8667 11.8667 12.4 11.6 12.9333C11.3333 13.4667 11.0667 14 10.8 14.4ZM14.5333 10.5333C14.6667 10.1333 14.8 9.73333 14.9333 9.33333C15.0667 8.93333 15.0667 8.4 15.0667 8C15.0667 7.46667 15.0667 7.06667 14.9333 6.66667C14.8 6.26667 14.6667 5.73333 14.5333 5.33333L14.6667 5.86667C14.6667 5.86667 14.4 5.86667 14.1333 6C13.8667 6.13333 13.2 6.13333 12.4 6.26667C12.4 6.53333 12.4 6.8 12.5333 7.06667C12.6667 7.33333 12.5333 7.6 12.5333 8C12.5333 8.4 12.5333 8.8 12.5333 9.06667C12.5333 9.33333 12.4 9.86667 12.4 10.1333C13.0667 10.2667 13.4667 10.2667 13.8667 10.4C14.2667 10.5333 14.4 10.5333 14.5333 10.5333Z" fill="#113050"/>
            </svg> {{ defaultLanguage }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="openMenu" class="header-bar__dark-overlay"></div>
  </div>
</template>

<script>
import storage from '../services/storage';
import * as configHelper from '../lib/configHelper';

export default {
  name: 'nav-bar',
  props: ['customerConfig', 'selectedLanguage'],
  data() {
    return {
      logo: '',
      altText: '',
      providerColor: '',
      requirements: {},
      help: {},
      byodHelp: '',
      byodRequirements: '',
      byodMainUrl: '',
      multipleLanguages: {},
      defaultLanguage: '',
      languages: '',
      openMenu: false,
    };
  },
  mounted() {
    // const req = require.context('../assets/logo', true, /^\.\/.*\.png$/);
    this.logo = this.customerConfig.logo;
    this.altText = ((this.customerConfig.commonSettings || []).find(({ key }) => key === 'byodMain') || { alt: null }).alt || `${this.customerConfig.name} BYO Home`;
    this.providerColor = this.customerConfig.color;
    const programId = this.$route.params.programId || storage.get('programId');
    const selectedProgram = this.customerConfig.programs.find(program => program.programName === programId);
    this.byodMainUrl = ((this.customerConfig.commonSettings || []).find(({ key }) => key === 'byodMain') || { url: this.customerConfig.byodPath }).url || '/';
    this.requirements = selectedProgram.programSettings.find(({ key }) => key === 'byodRequirements') || this.customerConfig.commonSettings.find(({ key }) => key === 'byodRequirements') || { excluded: true };
    this.help = selectedProgram.programSettings.find(({ key }) => key === 'byodHelp') || this.customerConfig.commonSettings.find(({ key }) => key === 'byodHelp') || { excluded: true };
    this.multipleLanguages = this.customerConfig.commonSettings.find(({ key }) => key === 'byodMultipleLanguages') || null;
    this.defaultLanguage = this.multipleLanguages ? this.multipleLanguages.languages.find(item => item.key !== this.selectedLanguage).value : null;
  },
  methods: {
    toggleLanguage(language) {
      const { languages } = this.multipleLanguages;
      const newLanguage = languages.find(item => item.value === language);
      this.defaultLanguage = languages.find(item => item.value !== language).value;
      this.$i18n.locale = `${newLanguage.key}`;
      if (this.$route.params.programId) {
        // remove last token (we have to assume it is the language indicator) and rejoin
        const programNameTokens = this.$route.params.programId.split('-');
        programNameTokens.pop();
        const programName = programNameTokens.join('-');

        const newProgram = `${programName}-${newLanguage.key}`;
        if (this.$route.meta.initialValues) {
          this.$router.push({ path: this.$router.path, params: { programId: newProgram }, query: { ...this.$route.query } });
        } else {
          this.$router.push({ path: `/signup/${newProgram}` });
        }
      }
      this.$emit('updateLanguage', this.$i18n.locale);
    },
  },
  computed: {
    helpClass() {
      if (this.requirements.excluded && (this.multipleLanguage && this.multipleLangues.excluded)) {
        return 'col-12';
      }
      if (!this.requirements.excluded && (this.multipleLanguages && !this.multipleLanguages.excluded)) {
        return 'col-4';
      }
      return 'col-6';
    },
    requirementsClass() {
      if (this.help.excluded && (this.multipleLanguage && this.multipleLangues.excluded)) {
        return 'col-12';
      }
      if (!this.help.excluded && (this.multipleLanguages && !this.multipleLanguages.excluded)) {
        return 'col-4';
      }
      return 'col-6';
    },
    languageButtonClass() {
      if (this.help.excluded && this.requirements.excluded) {
        return 'col-12';
      }
      if (!this.help.excluded && !this.requirements.excluded) {
        return 'col-4';
      }
      return 'col-6';
    },
  },
  watch: {
    selectedLanguage() {
      this.defaultLanguage = this.multipleLanguages ? this.multipleLanguages.languages.find(item => item.key !== this.selectedLanguage).value : null;
    },
  },
};
</script>

<style lang="scss">
@import '../styles/styles.scss';
@import '../styles/mixins.scss';

.header-bar {
   $navbar: &;
   height: 70px;
   box-shadow: 0 -1px 4px 0 rgba(123, 123, 123, 0.5);
   background-color: #fff;
   padding: 5px 5% 5px 5%;
   @include Tablet {
    height: 100px
   }
   .logo {
    height: 40px;
    margin-top: 5px;
    @include Tablet {
      margin-top: 0px;
      height: 56px
    }
   }

   .language-selector {
      background-color: #FFF;
      border: 1px solid #DBDBDB;
      width: 120px;
      padding: 8px;
      font-size: .75em;
      svg {
        padding-top: 3px;
      }
    }

    button.language-selector:focus {
      outline: 2px solid #185abc;
      }

   &__links {
    display: none !important;
    text-align: right;
    @include Tablet {
      display: flex !important;
    }
    &-item {
      align-self: center;
      a {
        font-size: .75em;
      }
    }

   }
   &__menu {
    transition: all .4s ease-in-out;
    position: absolute;
    overflow: hidden;
    top: 25px;
    right: 40px;
    z-index: 7;
    @include Tablet {
      display: none !important;
    }
    &-line {
      width: 25px;
      height: 2px;
      border-radius: 0.5px;
      margin-bottom: 7px;
      background-color: #4F4F4F;
      transition: all .3s ease-in-out;
    }

    &.is-menu-open {
      transform: rotate(90deg);
      transition: all .4s ease-in-out;
    }
    &.is-menu-open > .header-bar__menu-line:nth-child(1) {
      transform: rotate(-45deg) translate(-10px, 10px);
    }
    &.is-menu-open > .header-bar__menu-line:nth-child(2) {
      opacity: 0;
    }
    &.is-menu-open > .header-bar__menu-line:nth-child(3) {
      transform: rotate(45deg) translate(-3px, -3px);
    }
   }
   // START: MOBILE NAVBAR
   &__mobile-nav {
    background-color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    width: 75%;
    height: 100vh;
    overflow: hidden;
    visibility: hidden;
    transform: translate3d(1000px, 0, 0);
    z-index: 6;
    transition: all .4s ease-in-out;
    &.is-open {
      visibility: visible;
      transform: translate3d(0, 0, 0);
    }
    @include Tablet {
      display: none !important;
    }
    #{ $navbar }__mobile-links {
      height: 100%;
      margin: 0;
      padding: 153px 63px 0 32px;
      #{ $navbar }__link-item {
        border-top: 1px solid #DBDBDB;
        padding: 15px 0;
        width: 100%;
        &:last-child {
           border-bottom: 1px solid #DBDBDB;
        }
        a {
          font-size: 20px;
        }
        .language-selector {
          font-size: 18px;
          margin: 0;
          padding: 8px 0;
          width: 130px;
        }
      }
    }
   }

   &__dark-overlay {
      position: absolute;
      content: '';
      top: 0;
      height: 100vh;
      left: 0;
      right: 0;
      z-index: 1;
      background: rgba(0, 0, 0, 0.5);
      background-blend-mode: multiply;
      z-index: 3;
      transition: all .9s ease-in-out;
      @include Tablet {
        display: none !important;
      }
    }
   // END: MOBILE NAVBAR
}

.middle-align-flex {
  align-items: center;
  justify-content: center;
}

.back-link {
  color: #59c483;
  text-align: right;
}

.with-vp {
  color: $light-gray-text;
  font-size: .75em;
}
</style>
